import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/CancelModalMarketPlace.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/alert.svg';
import RespModal from '../Shared/RespModal';

function CancelModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="marketmodalsize" >
            <Image src={success} /><br /><br />
            <div id="marketmodalcontainsuccess">
                 {props.children}
            </div>
            <div class="marketcancelresploginbuttonouter">
            <Button
                id="yesresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onYesModal}
            >Yes
        </Button>
        <Button
                id="marketcancelresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >No
        </Button>
            </div>
        <br /><br />
        </div>
    </RespModal>
    );
}
export default CancelModal;